import React, {useState, useEffect} from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer'
import ProductForm from '../components/ProductForm';
import SolutionForm from '../components/SolutionForm';
import PartnerForm from '../components/PartnerForm';
import usePageSEO from '../hooks/usePageSEO'
import axios from "axios";
import Loader from '../components/Loader'

const Contact = () => {
    const [loading, setLoading] = useState(true);    
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    const siteUrl = process.env.REACT_APP_BACKEND_URL;
    const [pagedata, setPagedata] = useState("");
    const [contactWidget, setContactWidget] = useState("");
    const [officeTab, setOfficeTab] = useState([]);
    const [supportTab, setSupportTab] = useState([]);
    const [enquiryTab, setEnquiryTab] = useState([]);
    const [metaTitle, setMetaTitle] = useState('');
    const [metaDescription, setMetaDescription] = useState('');
    const [company, setCompany] = useState("");

    const getInitialState = () => {
        const value = 'Channel Partner';
        return value;
    };
    const [enquiry, setEnquiry] = useState(getInitialState);

    const dropdownHandleChange = (e) => {
        setEnquiry(e.target.value);
    };

  const fetchPagedata = () => {
    return axios.get(apiBaseUrl+`contactpage`).then((res) => {
      setPagedata(res.data.contactpage);
      setMetaTitle(res.data.contactpage.meta_title);
      setMetaDescription(res.data.contactpage.meta_description);
      setContactWidget(res.data.contactwidget);
      setOfficeTab(res.data.officeinfo);
      setSupportTab(res.data.supportinfo);
      setEnquiryTab(res.data.enquiryinfo);
      setCompany(res.data.company);
    });
  }; 

  useEffect(() => {
    setTimeout(() => {
      fetchPagedata()
        setLoading(false);
    }, 2000);
  }, []);  

  usePageSEO({
    title: `${metaTitle}`,
    description: `${metaDescription}`
  }) 

  function createMarkup(data) {
    return { __html: data };
  }

  return (
    <>
    <Header/>
        { loading && (<Loader /> )}
    <section className="section-content-block">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12 text-center">                       
                        <div className="about-us-intro">
							<p className="blue">{pagedata?.name}</p>
							<h2 className="heading">{pagedata?.page_heading}</h2>
                            <p dangerouslySetInnerHTML={createMarkup(pagedata?.short_description)}></p>
                        </div>                            
                    </div> 
					
                </div>
            </div> 

    </section>
		
	<div className="container"><hr /></div>
		
	<section className="section-content-block">

        <div 
            className="container contactus wow fadeIn animated" 
            style= {{ visibility: "visible", animationName: "fadeIn"  }}
        >

            <ul className="row nav nav-tabs">
                <li className="col-sm-4 text-center active" role="presentation">
                    <a href="#one" aria-controls="one" role="tab" data-toggle="tab">Office</a>
                </li>
                <li className="col-sm-4 text-center" role="presentation">
                    <a href="#two" aria-controls="two" role="tab" data-toggle="tab">Support</a>
                </li>
                <li className="col-sm-4 text-center" role="presentation">
                    <a href="#three" aria-controls="three" role="tab" data-toggle="tab">Enquiries</a>
                </li>
            </ul>


            <div className="tab-content">
                <div role="tabpanel" className="tab-pane fade in active" id="one">
                    <div className="row">
                        {officeTab.map((item, index)=>{
                            return(
                                <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12" key={index}> 
                                    <div className="process-step-1 text-left wow fadeIn animated" data-wow-delay="0.20s" 
                                        style= {{ visibility: "visible", animationDelay:  "0.2s", animationName: "fadeIn"  }}
                                        >
                                        <div className="map-icon"><img src="/images/map.svg" alt="" /></div> 
                                        <h3>{item?.title}</h3>
                                        <p>{item?.heading}</p>
                                        <div className="process-info">{item?.content1}</div>
                                    </div> 
                                </div> 
                            )
                        })}
                       

                    </div> 
                </div>
                <div role="tabpanel" className="tab-pane fade in " id="two">
                <div className="row">

                {supportTab.map((item, index)=>{
                    return(
                    <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12" key={index}> 
                        <div className="process-step-1 text-left wow fadeIn animated" data-wow-delay="0.20s" 
                                style= {{ visibility: "visible", animationDelay:  "0.2s", animationName: "fadeIn" }}
                                >
                                <div className="map-icon"><img src="/images/map.svg" alt="" /></div> 
                                <h3>{item?.title}</h3>
                                <p>{item?.heading}</p>
                                <div className="process-info">{item?.content1}</div>
                                {item?.content2 && (
                                    <div className="process-info">{item?.content2}</div>
                                )}
                                                                             
                        </div> 
                    </div>
                    )
                })}

                </div> 
                </div>
                <div role="tabpanel" className="tab-pane fade in " id="three">
                <div className="row">
                {enquiryTab.map((item, index)=>{
                    return(                    
                    <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12" key={index}> 
                        <div className="process-step-1 text-left wow fadeIn animated" data-wow-delay="0.20s"
                            style= {{ visibility: "visible", animationDelay:  "0.2s", animationName: "fadeIn" }}
                                >
                            <div className="map-icon"><img src="/images/map.svg" alt="" /></div> 
                            <h3>{item?.title}</h3>
                            <p>{item?.heading}</p>
                            <div className="process-info">{item?.content1}</div>
                            <div className="process-info">{item?.content2}</div>
                        </div> 
                    </div>
                    )
                })}

                </div> 
                </div>
            </div>
             
        </div>
    </section>
	
    <div className="container"><hr /></div>
		
	
    <section className="section-content-block">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12 text-center">                       
                        <div className="about-us-intro">
							<p className="blue">{contactWidget?.name}</p>
							<h2 className="heading">{contactWidget?.heading}</h2>
                            <p dangerouslySetInnerHTML={createMarkup(contactWidget?.description)}></p>
							
                        </div>                            
                    </div> 
					
                </div>
				
				<div className="row contact-form">
				
                    <div className="col-sm-6">
                        <iframe 
                            title='Junna Solar Google Map' 
                            src={company?.google_map}
                            width="100%" 
                            height="545"
                            style={{ border: 0}} 
                            allowFullScreen="" 
                            loading="lazy" 
                            referrerPolicy="no-referrer-when-downgrade"></iframe>
                    </div>
                    <div className="col-sm-6">

                        <div className="appointment-form-wrapper clearfix">
                            <div className="row select-wrapper">
                                <div className="form-group col-md-12">
                                    <label className='lbl'>Enquiry type</label>
                                    <div className="select-style">                                    
                                        <select 
                                            className="form-control" 
                                            name="enquiry_type"
                                            value={enquiry}
                                            onChange={dropdownHandleChange}>
                                            <option value={'Channel Partner'}>Channel Partner</option>
                                            <option value={'Residential'}>Residential</option>
                                            <option value={'Housing Society'}>Housing Society</option>
                                            <option value={'Commercial'}>Commercial</option>
                                            <option value={'Industrial'}>Industrial</option>
                                            <option value={'Floating'}>Floating</option>
                                            <option value={'Institutional'}>Institutional</option>
                                            <option value={'Solar Module'}>Solar Module</option>
                                            <option value={'Solar Cell'}>Solar Cell</option>
                                            <option value={'Mounting Structure'}>Mounting Structure</option>
                                            <option value={'Service Enquiry'}>Service Enquiries</option>
                                            <option value={'Other'}>Others</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                                {enquiry === 'Channel Partner' && (
                                    <PartnerForm prm={enquiry} />
                                )}  
                                {(enquiry === 'Solar Module' || 
                                  enquiry === 'Solar Cell' || 
                                  enquiry === 'Mounting Structure' ||
                                  enquiry === 'Service Enquiry') && (
                                    <ProductForm prm={enquiry} />
                                )}
                                {(enquiry === 'Residential' || 
                                  enquiry === 'Housing Society' || 
                                  enquiry === 'Commercial' ||
                                  enquiry === 'Industrial' ||
                                  enquiry === 'Institutional' ||
                                  enquiry === 'Floating' ||
                                  enquiry === 'Other') && (
                                    <SolutionForm prm={enquiry} />
                                )}                                                              

                        </div>
                    </div>

				</div>
            </div> 

    </section>
	
	<div className="container"><hr /></div>
	
	<section className="section-content-block "> 
			<div className="container">
				<div className="row">
					<div className="col-sm-12 col-12">
						 <img className='border-radius' alt={pagedata?.name} src={`${siteUrl}${contactWidget?.image}`} />
					</div>
				</div>
			</div>
    </section>

    <Footer/>    
    </>
  )
}

export default Contact